
export default function SolutionSection() {
  const solutions = [
    {
      number: '1',
      title: '停止ロス（時間）→ 稼働時間へ変換',
      subtitle: '自動交換で段取り短縮、回復した分だけ生産',
      description: '30分の作業を自動化×10回/日＝2.5h/シフト　回復',
      calculation: '@30分 x 10回 x 365日 × 3シフト x ¥4,000/h ＝約2,190万円/年',
      icon: 'ri-time-line',
      color: 'yellow'
    },
    {
      number: '2',
      title: 'バラつき（品質）→ 再現性で固定',
      subtitle: '自動トルク＋履歴ログ＝同じ締め＝同じ結果',
      description: 'ppm↓。監査・客先問合せにも客観データで即回答',
      calculation: '品質安定化により再加工・クレーム対応コストを削減',
      icon: 'ri-settings-line',
      color: 'gray'
    },
    {
      number: '3',
      title: '属人作業（リスク）→ 装置内に標準化',
      subtitle: '条件・手順を機械に封入 → 自動化システムへの段取り',
      description: '新人でも同品質・同タクト',
      calculation: '教育短縮／離職・欠員の影響を極小化',
      icon: 'ri-robot-line',
      color: 'yellow'
    }
  ];

  return (
    <section id="solution" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            【micBoxが止血する3つの出血点】
          </h2>
          <p className="text-xl text-gray-600">
            自動反転・自動トルク・履歴ログで根本解決
          </p>
        </div>

        <div className="space-y-12">
          {solutions.map((solution, index) => (
            <div key={index} className={`bg-${solution.color}-50 rounded-2xl p-8 lg:p-12 border border-${solution.color}-200`}>
              <div className="grid lg:grid-cols-2 gap-8 items-center">
                <div className="space-y-6">
                  <div className="flex items-center space-x-4">
                    <div className={`w-16 h-16 bg-${solution.color}-600 text-white rounded-full flex items-center justify-center text-2xl font-bold`}>
                      {solution.number}
                    </div>
                    <div className={`w-12 h-12 bg-${solution.color}-100 rounded-lg flex items-center justify-center`}>
                      <i className={`${solution.icon} text-2xl text-${solution.color}-600`}></i>
                    </div>
                  </div>
                  
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                      {solution.title}
                    </h3>
                    <p className={`text-lg font-semibold text-${solution.color}-700 mb-4`}>
                      {solution.subtitle}
                    </p>
                    <p className="text-gray-700 mb-4">
                      {solution.description}
                    </p>
                    <div className={`bg-${solution.color}-100 p-4 rounded-lg border border-${solution.color}-200`}>
                      <p className={`text-${solution.color}-800 font-semibold`}>
                        {solution.calculation}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex justify-center">
                  {index === 0 ? (
                    <div className="max-w-md w-full">
                      <div className="relative rounded-lg shadow-lg overflow-hidden">
                        <iframe
                          width="100%"
                          height="300"
                          src="https://www.youtube.com/embed/ntJQ9T0Iizg"
                          title="micBox工具取付け～AI摩耗判定"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          className="w-full"
                        ></iframe>
                      </div>
                      <p className="text-center text-gray-700 font-semibold mt-4">
                        工具取付け～AI摩耗判定<br />
                        <span className="text-sm text-red-600">（音量注意‼ 音声は動画の内容に関連しません）</span>
                      </p>
                    </div>
                  ) : index === 1 ? (
                    <div className="max-w-md w-full">
                      <div className="relative rounded-lg shadow-lg overflow-hidden">
                        <iframe
                          width="100%"
                          height="300"
                          src="https://www.youtube.com/embed/xSsMFZirpzU"
                          title="micBox自動チップ交換作業"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          className="w-full"
                        ></iframe>
                      </div>
                      <p className="text-center text-gray-700 font-semibold mt-4">
                        自動チップ交換作業（各種コーナーチェンジ方式含）<br />
                        <span className="text-sm text-red-600">（音量注意‼ 音声は動画の内容に関連しません）</span>
                      </p>
                    </div>
                  ) : (
                    <div className="max-w-md w-full">
                      <div className="relative rounded-lg shadow-lg overflow-hidden">
                        <iframe
                          width="100%"
                          height="300"
                          src="https://www.youtube.com/embed/-dAQJwyJhHI"
                          title="micBoxシステム内3次元モデル管理"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          className="w-full"
                        ></iframe>
                      </div>
                      <p className="text-center text-gray-700 font-semibold mt-4">
                        システム内3次元モデル管理<br />
                        <span className="text-sm text-red-600">（音量注意‼ 音声は動画の内容に関連しません）</span>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-gray-800 to-gray-900 text-white p-8 rounded-2xl">
            <h3 className="text-2xl font-bold mb-4">micBoxの自動化プロセス</h3>
            <div className="grid md:grid-cols-5 gap-4 text-sm">
              
              <div className="bg-yellow-500/20 p-4 rounded-lg border border-yellow-400/30">
                <div className="w-8 h-8 bg-yellow-500 text-gray-900 rounded-full flex items-center justify-center mx-auto mb-2 font-bold">1</div>
                <p>パレットから<br />カッターアーバーを<br />ピックアップ</p>
              </div>
              
              <div className="bg-yellow-500/20 p-4 rounded-lg border border-yellow-400/30">
                <div className="w-8 h-8 bg-yellow-500 text-gray-900 rounded-full flex items-center justify-center mx-auto mb-2 font-bold">2</div>
                <p>Box内の<br />スピンドルに取付</p>
              </div>
              
              <div className="bg-yellow-500/20 p-4 rounded-lg border border-yellow-400/30">
                <div className="w-8 h-8 bg-yellow-500 text-gray-900 rounded-full flex items-center justify-center mx-auto mb-2 font-bold">3</div>
                <p>AI自動<br />摩耗検査</p>
              </div>
              
              <div className="bg-yellow-500/20 p-4 rounded-lg border border-yellow-400/30">
                <div className="w-8 h-8 bg-yellow-500 text-gray-900 rounded-full flex items-center justify-center mx-auto mb-2 font-bold">4</div>
                <p>摩耗インサート<br />のみ交換</p>
              </div>
              
              <div className="bg-yellow-500/20 p-4 rounded-lg border border-yellow-400/30">
                <div className="w-8 h-8 bg-yellow-500 text-gray-900 rounded-full flex items-center justify-center mx-auto mb-2 font-bold">5</div>
                <p>パレットへ<br />返却</p>
              </div>
              
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
